// 約定結果タブ (AC-BSP-037) のフィルタの保持 (AC-SC-031、 #12745)。 入札一覧の絞り込みとは別の key で持つ。
import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import { Side } from '@ebalance/proto/bfftypes/v1/side_pb'

import { KOMA_COUNT } from '~/constants/koma'
import { JEPX_AREA_CODES } from '~/models/area'
import { defineFilterCodec, oneOf } from '~/models/filterCodec'

import { readonlySetOf } from './readonlySetField'
import { SPOT_BID_STATUS_FILTER_CATEGORIES } from './spotBidStatusCategory'
import type { SpotExecutionResultFilter } from './spotExecutionResult'

export const SPOT_EXECUTION_RESULT_FILTER_STORAGE_KEY =
  'ebalance-spot-execution-result-filters'

const KOMA_NUMBERS = Array.from({ length: KOMA_COUNT }, (_, i) => i + 1)

export const spotExecutionResultFilterCodec =
  defineFilterCodec<SpotExecutionResultFilter>({
    defaults: () => ({
      komas: new Set(),
      areas: new Set(),
      sides: new Set(),
      statuses: new Set(),
    }),
    fields: {
      komas: readonlySetOf(oneOf(KOMA_NUMBERS)),
      // 保存するのは JEPX の取引対象エリア。 業務エリアで外すのは表示する時 ([[keepSelectableAreas]])
      areas: readonlySetOf(oneOf<AreaCode>(JEPX_AREA_CODES)),
      sides: readonlySetOf(oneOf<Side>([Side.BUY, Side.SELL])),
      statuses: readonlySetOf(oneOf(SPOT_BID_STATUS_FILTER_CATEGORIES)),
    },
  })

/**
 * 選んだエリアのうち、 いま選べるエリア (業務エリア。 取得中・取得失敗の間は全エリア) に無いものを外す。
 * 復元したエリアが業務エリア外になっていても、 0 件の一覧やラベルの無い chip を作らないため。 外すのは
 * 表示と絞り込みの時だけで、 保存値は変えない (業務エリアを戻すと選択も戻る)。 全部外れたら「すべて」。
 * 約定結果タブとオペレーション履歴タブが使う。 外すものが無ければ同じ選択を返す。
 */
export function keepSelectableAreas(
  selected: ReadonlySet<AreaCode>,
  selectable: readonly AreaCode[],
): ReadonlySet<AreaCode> {
  const kept = [...selected].filter((code) => selectable.includes(code))
  return kept.length === selected.size ? selected : new Set(kept)
}
